import { BigNumber } from "@/components/core-components/molecules/BigNumber/big-number";
import {
  Icons,
  LinkButton,
  Typography,
} from "@flash-tecnologia/hros-web-ui-v2";
import { useSetupSummary } from "../../context/setup-summary-context";
import * as SC from "./setup-summary.styles";
import { setEventTracking } from "@/utils";
import { TrackingEvents } from "../../types";
import { EmployeeErrorsAccordion } from "../../components/EmployeeErrorsAccordion/employee-errors-accordion";

export const SetupSummary = () => {
  const { summaryData } = useSetupSummary();

  return (
    <SC.ResponsiveContainer>
      <SC.Grid>
        <SC.GridItem columnSpan={8}>
          <Typography.Headline7 color="neutral.20" weight={700}>
            Configuração concluída!
          </Typography.Headline7>
          <Typography.Body4 weight={400} color="neutral.40">
            Confira agora o resultado e descubra o impacto da sua configuração
          </Typography.Body4>
        </SC.GridItem>
        {summaryData.companiesCreated > 0 && (
          <SC.GridItem columnSpan={2}>
            <BigNumber
              value={`${summaryData.companiesCreated}`}
              title="Empresas"
            >
              <div>
                <LinkButton
                  variant="default"
                  underlined={false}
                  onClick={() => {
                    setEventTracking(
                      TrackingEvents.SETUP_SUMMARY_COMPLETED_COMPANIES_CLICKED
                    );
                    window.open(
                      `${window.location.origin}/settings/economic-group`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  Visualizar <Icons name="IconExternalLink" />
                </LinkButton>
              </div>
            </BigNumber>
          </SC.GridItem>
        )}
        {summaryData.membersCreated > 0 && (
          <SC.GridItem columnSpan={2}>
            <BigNumber value={`${summaryData.membersCreated}`} title="Pessoas">
              <div>
                <LinkButton
                  variant="default"
                  underlined={false}
                  onClick={() => {
                    setEventTracking(
                      TrackingEvents.SETUP_SUMMARY_COMPLETED_MEMBERS_CLICKED
                    );
                    window.open(
                      `${window.location.origin}/employees`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  Visualizar <Icons name="IconExternalLink" />
                </LinkButton>
              </div>
            </BigNumber>
          </SC.GridItem>
        )}
        {summaryData.jobRolesCreated > 0 && (
          <SC.GridItem columnSpan={2}>
            <BigNumber value={`${summaryData.jobRolesCreated}`} title="Cargos">
              <div>
                <LinkButton
                  variant="default"
                  underlined={false}
                  onClick={() => {
                    setEventTracking(
                      TrackingEvents.SETUP_SUMMARY_COMPLETED_JOB_ROLES_CLICKED
                    );
                    window.open(
                      `${window.location.origin}/settings/roles`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  Visualizar <Icons name="IconExternalLink" />
                </LinkButton>
              </div>
            </BigNumber>
          </SC.GridItem>
        )}
        {summaryData.departmentsCreated > 0 && (
          <SC.GridItem columnSpan={2}>
            <BigNumber
              value={`${summaryData.departmentsCreated}`}
              title="Departamentos"
            >
              <div>
                <LinkButton
                  variant="default"
                  underlined={false}
                  onClick={() => {
                    setEventTracking(
                      TrackingEvents.SETUP_SUMMARY_COMPLETED_DEPARTMENTS_CLICKED
                    );
                    window.open(
                      `${window.location.origin}/settings/departments`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  Visualizar <Icons name="IconExternalLink" />
                </LinkButton>
              </div>
            </BigNumber>
          </SC.GridItem>
        )}
      </SC.Grid>
      {summaryData.employeeErrors.length > 0 && (
        <SC.Grid>
          <SC.GridItem columnSpan={8}>
            <EmployeeErrorsAccordion employees={summaryData.employeeErrors} />
          </SC.GridItem>
        </SC.Grid>
      )}
    </SC.ResponsiveContainer>
  );
};
